"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrentProviderGames = void 0;
var keys_1 = require("../keys");
var game_api_1 = require("@l2p/game-api");
var react_1 = require("react");
var useQuery_1 = require("../useQuery");
var apps_shared_1 = require("@l2p/apps-shared");
var geo_1 = require("../geo");
var currencies_1 = require("../currencies");
var useCache_1 = require("../useCache");
var CURRENT_CURRENCY = 'current_currency';
var useCurrentProviderGames = function (_a) {
    var _b, _c;
    var id = _a.id;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var _d = (0, useCache_1.useCache)(), getDataFromCache = _d.getDataFromCache, setDataToCache = _d.setDataToCache;
    var geoData = (0, geo_1.useGeo)().data;
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var isReady = (0, react_1.useMemo)(function () {
        return !!id &&
            !!(Object.keys(breakpoints).length > 0 && geoData && currentCurrency);
    }, [breakpoints, geoData, currentCurrency, id]);
    var _e = (0, useQuery_1.useQuery)({
        canRender: isReady,
        path: keys_1.GAMES_BY_PROVIDER,
        payload: {
            devices: [
                breakpoints.mobile || breakpoints.tablet
                    ? game_api_1.GameDeviceTypeEnum.Mobile
                    : game_api_1.GameDeviceTypeEnum.Desktop,
                game_api_1.GameDeviceTypeEnum.Universal,
            ],
            allowedCountries: ((_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode)
                ? [(_c = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _c === void 0 ? void 0 : _c.countryCode]
                : undefined,
            currencies: currentCurrency ? [currentCurrency] : undefined,
            id: id,
        },
        revalidateOnMount: true,
    }), data = _e.data, error = _e.error, isLoading = _e.isLoading, mutate = _e.mutate, isValidating = _e.isValidating;
    (0, react_1.useEffect)(function () {
        var prevCurrency = getDataFromCache(CURRENT_CURRENCY);
        if (!prevCurrency || prevCurrency !== currentCurrency) {
            mutate();
            setDataToCache(CURRENT_CURRENCY, currentCurrency);
        }
    }, [getDataFromCache, setDataToCache, currentCurrency, mutate]);
    return (0, react_1.useMemo)(function () { return ({
        mutate: mutate,
        data: data === null || data === void 0 ? void 0 : data.data,
        isLoading: isLoading,
        isValidating: isValidating,
        error: error,
    }); }, [data, isLoading, isValidating, mutate, error]);
};
exports.useCurrentProviderGames = useCurrentProviderGames;
